module.exports = __webpack_public_path__ + "media/11_16.697607f5.wav";